import { t } from "@/i18n-js/instance";
import { FeatureRow } from "../FeatureRow";
import { SectionWrapper } from "./SectionWrapper";
import { annualOnlyKey } from "./constants";

export const Services = () => (
  <SectionWrapper sectionName={t("pricing_plans.section.services")}>
    <FeatureRow
      title={t("pricing_plans.feature.concierge")}
      basic={false}
      professional={false}
      enterprise={t(annualOnlyKey)}
      business={false}
    />
    <FeatureRow
      title={t("pricing_plans.feature.support_dedicated")}
      basic={false}
      professional={false}
      enterprise={t(annualOnlyKey)}
      business={false}
    />
    <FeatureRow
      title={t("pricing_plans.feature.business_review")}
      basic={false}
      professional={false}
      enterprise={t(annualOnlyKey)}
      business={false}
    />
    <FeatureRow
      title={t("pricing_plans.feature.payments_migration")}
      basic
      professional
      enterprise
      business
    />
    <FeatureRow
      title={t("pricing_plans.feature.courses_migration")}
      basic={false}
      professional={false}
      enterprise={t(annualOnlyKey)}
      business={t(annualOnlyKey)}
    />
  </SectionWrapper>
);
